export const getDocumentUrl = (applicationId: string, type: string) => {
  return `${process.env.REACT_APP_DOCUMENT_BASE_URL}/${applicationId}/documents/${type}`
}
